// extracted by mini-css-extract-plugin
export default {"root":"_3TtYo","content":"_2E7Th"};